import React, { FC } from 'react';
import { KnowledgeFeedRaw as KnowledgeFeed } from '@rbx/knowledge-feed';
import { getRobloxDomain } from '@modules/utilities/constants/baseUrl';
import unifiedLoggerClient, {
  PRODUCT_NAME,
} from '@modules/eventStream/implementations/unifiedLoggerClient';

const ExpertSection: FC<React.PropsWithChildren> = () => {
  return (
    <KnowledgeFeed
      robloxSiteDomain={getRobloxDomain()}
      surfaceType={PRODUCT_NAME}
      unifiedLoggerClient={unifiedLoggerClient}
    />
  );
};

export default ExpertSection;
